import Modal from "../../../global/Modal";
import AddReferralForm from "./AddReferralForm";

export default function AddReferralModal({ open, onClose, onSubmit }) {
  return (
    <Modal open={open} onClose={onClose} maxWidth="xl">
      <div className="p-2">
        <AddReferralForm submit={onSubmit} />
      </div>
    </Modal>
  );
}